import { useTranslation } from 'react-i18next';
import NumberField from '@/components/fields/NumberField';

const BmpPerformanceInnerForm = () => {
    const { t } = useTranslation('performanceResult');

    return (
        <>
            <NumberField
                name="percentage"
                label={t('bmp.form.percentage')}
                min={0}
                precision={1}
                suffixElement={t('bmp.form.percentageSuffix')}
            />
        </>
    );
};

export default BmpPerformanceInnerForm;
